import React, { FC } from "react";
import cn from "classnames";
import { IList } from "./types";

interface Props {
  list: IList;
  isDisableIndent?: boolean;
}

export const RenderList: FC<Props> = ({
  list: { className, items },
  isDisableIndent,
}) => {
  return (
    <ul className={cn({ "-mt-7": !isDisableIndent }, className)}>
      {items.map(({ id, item, list }) => {
        const hasColon = item.includes(":");
        const [boldPart, normalPart] = hasColon ? item.split(":") : [item, ""];

        return (
          <li key={id}>
            <span>
              {hasColon ? (
                <>
                  <span className="font-bold">{boldPart}:</span> {normalPart}
                </>
              ) : (
                <span>{item}</span>
              )}
            </span>
            {list && <RenderList list={list} isDisableIndent />}
          </li>
        );
      })}
    </ul>
  );
};
